// extracted by mini-css-extract-plugin
export default {"suppressOutline":"_40bcbc5a"};